import Affiliate from './Affiliate';
import NodeCookie from './NodeCookie';

export default class OptimiseMedia extends Affiliate {
    constructor() {
        super();
        this.affiliateName = 'optimise-media';
        this.cookieDomain = new NodeCookie();
        this.cookieNames = ['serverToServerClickId', 'serverToServerAffiliate'];
        this.validStores = ['PBCA', 'PBAU', 'PBUS', 'PBMY', 'PBTH', 'PBPH', 'PBVN', 'PBSG', 'PBHK', 'PBUK', 'PBID'];
    }

    prepareCookie() {
        const { sskey } = this.urlParams;
        this.cookieDomain.sendCookie({ name: 'serverToServerClickId', value: sskey, expiryInDays: 30, httponly: 1 });
        this.cookieDomain.sendCookie({ name: 'serverToServerAffiliate', value: 'optimise-media', expiryInDays:30, httponly: 1 });
    }
}


// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/OptimiseMedia.js